import { Box, Divider, Grid, Switch, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import CommonButton from "../../common/components/CommonButton";
import theme from "../../theme";
import CommonCard from "../../common/components/CommonCard";
import BarChart from "./BarChart";
import LineChart from "./LineChart";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { getScoreGraph } from "../../api/scoreApi";
import { Semesters, ServiceOffer, ServiceTypes, SkillPath, TestType } from "../../common/const";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";

const Semester = {
    One: 'Semester 1',
    Two: 'Semester 2'
};

const Type = {
    Assignment: 'Assignments',
    Quiz: 'Quizzes',
    Test: 'Tests'
};

const Progress = ({
    pathname,
    fromMentor,
    tutoringType,
    currentService,
    studentId,
    subService
}) => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [semester, setSemester] = useState(Semester.One);
    const [type, setType] = useState(Type.Assignment);
    const [chartType, setChartType] = useState(true)
    const [chartData, setChartData] = useState([]);
    const getStats = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getScoreGraph(pathname !== SkillPath ? Semesters[semester] : '', (pathname === SkillPath ? ServiceOffer.skillCoach : ServiceTypes[tutoringType]) || currentService, TestType[type], user?.student_id || studentId, subService);
            setChartData(response?.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    };

    useEffect(() => {
        getStats();
    }, [tutoringType, type, semester, currentService, subService]);

    return (
        <CommonCard
            paddingBottom="0px"
            padding="0px"
            borderRadius={2}
            headerContent={
                <Fragment>
                    <Grid container spacing={2} p={2}>
                        <Grid item md={fromMentor ? 6 : 4}>
                            {(pathname !== SkillPath) ? (
                                <Box mt={2} display="flex" gap={1}>
                                    <CommonButton
                                        label={Semester.One}
                                        width="100px"
                                        fontWeight={600}
                                        color={semester === Semester.One ? theme.palette.secondary.main : theme.palette.background.dark}
                                        background={semester === Semester.One ? theme.palette.primary.main : theme.palette.background.main}
                                        handleClick={() => setSemester(Semester.One)}
                                        marginBottom="0px"
                                        height="35px"
                                    />
                                    <CommonButton
                                        label={Semester.Two}
                                        width="100px"
                                        fontWeight={600}
                                        color={semester === Semester.Two ? theme.palette.secondary.main : theme.palette.background.dark}
                                        background={semester === Semester.Two ? theme.palette.primary.main : theme.palette.background.main}
                                        handleClick={() => setSemester(Semester.Two)}
                                        marginBottom="0px"
                                        height="35px"
                                    />
                                </Box>
                            ) : (
                                <Typography fontWeight={600} mt={2}>Progress</Typography>
                            )}
                        </Grid>
                        <Grid item md={5}>
                            <Box mt={2} display="flex" gap={1}>
                                <CommonButton
                                    label={Type.Assignment}
                                    width="120px"
                                    fontWeight={600}
                                    color={type === Type.Assignment ? theme.palette.secondary.main : theme.palette.background.dark}
                                    background={type === Type.Assignment ? theme.palette.primary.main : theme.palette.background.main}
                                    handleClick={() => setType(Type.Assignment)}
                                    marginBottom="0px"
                                    height="35px"
                                />
                                <CommonButton
                                    label={Type.Quiz}
                                    width="100px"
                                    fontWeight={600}
                                    color={type === Type.Quiz ? theme.palette.secondary.main : theme.palette.background.dark}
                                    background={type === Type.Quiz ? theme.palette.primary.main : theme.palette.background.main}
                                    handleClick={() => setType(Type.Quiz)}
                                    marginBottom="0px"
                                    height="35px"
                                />
                                <CommonButton
                                    label={Type.Test}
                                    width="100px"
                                    fontWeight={600}
                                    color={type === Type.Test ? theme.palette.secondary.main : theme.palette.background.dark}
                                    background={type === Type.Test ? theme.palette.primary.main : theme.palette.background.main}
                                    handleClick={() => setType(Type.Test)}
                                    marginBottom="0px"
                                    height="35px"
                                />
                            </Box>
                        </Grid>
                        <Grid item md={fromMentor ? 6 : 3}>
                            <Box
                                mt={2}
                                display="flex"
                                gap={1}
                                alignItems="center"
                                sx={{
                                    background: '#FAFAFA',
                                    paddingLeft: 1,
                                    borderRadius: 1
                                }}
                            >
                                <Typography fontSize={13}>Line Chart</Typography>
                                <Switch
                                    size="Medium"
                                    checked={chartType}
                                    onChange={(e) => setChartType(e.target.checked)}
                                />
                                <Typography fontSize={13}>Bar Chart</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Divider />
                </Fragment>
            }
            content={
                chartType === true ? (
                    <BarChart
                        colors={[type === Type.Assignment ? '#10AE2D' : type === Type.Quiz ? theme.palette.primary.main : theme.palette.secondary.main]}
                        categories={chartData.map((a) => a.month)}
                        chartSeries={[
                            type === Type.Assignment ? {
                                name: 'Assignments',
                                data: chartData.map((a) => a.score)
                            } :
                                type === Type.Quiz ? {
                                    name: 'Quizzes',
                                    data: chartData.map((a) => a.score)
                                } :
                                    {
                                        name: 'Tests',
                                        data: chartData.map((a) => a.score)
                                    }
                        ]}
                        percentage
                    />
                ) : (
                    <LineChart
                        colors={[type === Type.Assignment ? '#10AE2D' : type === Type.Quiz ? theme.palette.primary.main : theme.palette.secondary.main]}
                        categories={chartData.map((a) => a.month)}
                        chartSeries={[
                            type === Type.Assignment ? {
                                name: 'Assignments',
                                data: chartData.map((a) => a.score)
                            } :
                                type === Type.Quiz ? {
                                    name: 'Quizzes',
                                    data: chartData.map((a) => a.score)
                                } :
                                    {
                                        name: 'Tests',
                                        data: chartData.map((a) => a.score)
                                    }
                        ]}
                    />
                )
            }
        />
    )
}

export default Progress;